//import axios from "axios";
import ApiService from "@/core/services/api.service";
// action types
export const OBTENER_COMPONENTES = "obtenerComponentes";
export const OBTENER_COMPONENTE = "obtenerComponente";
export const REGISTRAR_COMPONENTE = "registrarComponente";
export const ACTUALIZAR_COMPONENTE = "actualizarComponente";
// mutation types
export const SET_COMPONENTES = "setComponentes";
export const SET_COMPONENTE = "setComponente";

const state = {
    componentes: [],
    componente:[]
}

const getters = {
    obtenerComponentes(state) {
      return state.componentes;
    },
}

const actions = {
    async [OBTENER_COMPONENTES](context, estadoId) {

        /*
        * Si el estado es null va a traer a todas las etnias, de lo contrario va a traer los etnias por estado
        *
        */
        let endpoint = 'api/Componentes'
        if(estadoId){
            endpoint = `api/Componentes/GetComponentesActivos/${estadoId}`
        }

        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_COMPONENTES, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)

                    //context.commit(SET_ERROR, response.data.errors);
                });
        });       
    },

    async [OBTENER_COMPONENTE](context, id){
        
        return new Promise(resolve => {
            ApiService.query(`apiconsume/edit/${id}?endpoint=api/Componentes/`)
                .then(({ data }) => {
                    context.commit(SET_COMPONENTE, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    
    },

    async [REGISTRAR_COMPONENTE](context, datosComponente){
        return new Promise(resolve => {
             ApiService.post(`apiconsume/create?endpoint=api/Componentes`, datosComponente)
                 .then(({ data }) => {
                     context.commit(SET_COMPONENTE, data.data);
                     resolve(data)
                 })
                 .catch((error) => {
                     console.log(error)
                     //context.commit(SET_ERROR, response.data.errors);
                 });
         });   
    },

    async [ACTUALIZAR_COMPONENTE](context, datosComponente){
        let id = datosComponente.id;
        
        return new Promise(resolve => {
            ApiService.post(`apiconsume/update/${id}?endpoint=api/Componentes/UpdateEtnia/`, datosComponente)
                .then(({ data }) => {
                    context.commit(SET_COMPONENTE, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    
    }

}

const mutations = {
    [SET_COMPONENTES](state, data) {
        state.componentes = data;
    },

    [SET_COMPONENTE](state, data) {
        state.componente = data;
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}